import { render, staticRenderFns } from "./InvoiceDuePeriod.vue?vue&type=template&id=b59c0680&scoped=true"
import script from "./InvoiceDuePeriod.vue?vue&type=script&lang=js"
export * from "./InvoiceDuePeriod.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDuePeriod.vue?vue&type=style&index=0&id=b59c0680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59c0680",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
